import { render, staticRenderFns } from "./CardListModulesProgress.vue?vue&type=template&id=456847be&scoped=true"
import script from "./CardListModulesProgress.vue?vue&type=script&lang=js"
export * from "./CardListModulesProgress.vue?vue&type=script&lang=js"
import style0 from "./CardListModulesProgress.vue?vue&type=style&index=0&id=456847be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456847be",
  null
  
)

export default component.exports